<template>
  <section class="payment-methods-container">
    <v-container class="py-0">
      <div class="w-full">
        <!-- <div class="headline-m mb-4">
        วิธีการชำระเงิน
      </div> -->

        <template v-if="isShowPayAtStoreMethod">
          <h4 class="text-lg payment-label">
            ชำระเงินที่สาขา
          </h4>
          <div class="chanel-payment-grid">
            <ButtonPayment
              v-for="item in payAtStoreList"
              :key="item.id"
              :hasError="isErrorRequirePayment"
              :name="item.title"
              :image="iconBank[item.id]"
              :selected="paymentId === item.id"
              :label="item.short_description"
              data-pptr="payment_type_id"
              @click="onSelectPaymentMethod(item)"
            />
          </div>
        </template>

        <template v-else>
          <template v-if="isShowFullPaymentMethod">
            <h4 class="text-lg payment-label">
              ชำระเงินแบบเต็มจำนวน
            </h4>
            <div class="chanel-payment-grid">
              <ButtonPayment
                v-for="item in fullPaymentList"
                :key="item.id"
                :hasError="isErrorRequirePayment"
                :name="item.title"
                :image="iconBank[item.id]"
                :selected="paymentId === item.id"
                :label="item.short_description"
                data-pptr="payment_type_id"
                @click="onSelectPaymentMethod(item)"
              />
            </div>
          </template>
          <template v-if="isShowInstallmentMethod">
            <h4 class="text-lg payment-label">
              ผ่อนชำระด้วยบัตรเครดิต
            </h4>
            <div class="chanel-payment-grid">
              <ButtonPayment
                v-for="item in installmentList"
                :key="item.id"
                :hasError="isErrorRequirePayment"
                :name="item.title"
                :image="iconBank[item.id]"
                :selected="paymentId === item.id"
                :label="item.short_description"
                :items="JSON.parse(JSON.stringify(item.dropdown))"
                data-pptr="payment_type_id"
                @click="onSelectPaymentMethod(item)"
                @updateInstallmentPlan="handleUpdateInstallmentPlan"
              />
            </div>
          </template>
          <template v-if="isShowAppMethod">
            <h4 class="text-lg payment-label">
              ชำระผ่านแอพพลิเคชั่น
            </h4>
            <div class="chanel-payment-grid">
              <ButtonPayment
                v-for="item in appList"
                :key="item.id"
                :hasError="isErrorRequirePayment"
                :name="item.title"
                :image="iconBank[item.id]"
                :selected="paymentId === item.id"
                :label="item.short_description"
                data-pptr="payment_type_id"
                @click="onSelectPaymentMethod(item)"
              />
            </div>
          </template>
        </template>
      </div>

      <template v-if="isVerifyRecaptcha">
        <Recaptcha @validate="validate" />
      </template>

      <div ref="beforeCheckoutAction"></div>

      <div class="payment-methods-actions-container">
        <v-btn
          class="font-bold"
          depressed
          large
          :color="colorBnn['color-bnn']"
          :disabled="disabledButton"
          :loading="loading"
          @click="checkValid ? onSubmit() : false"
        >
          ชำระเงินค้ำประกัน
        </v-btn>

        <BaseStaffQrCode />
      </div>
    </v-container>
  </section>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import iconBank from '@/config/iconBank'
import Recaptcha from '@/components/Recaptcha'
import { showKBankEmbedUI } from '@/utils/kbank'
import { STOCK_CARD_TYPE } from '@/config/stockCard'
import colorBnn from '@/config/color'

export default {
  name: 'CheckoutPaymentMethod',

  props: {
    loading: Boolean,
    isErrorRequirePayment: Boolean,
  },

  components: {
    BaseStaffQrCode: () =>
      import('@/components/base/BaseStaffQrCode'),
    ButtonPayment: () => import('@/components/bnn/ButtonPayment'),
    Recaptcha,
  },

  computed: {
    ...mapState({
      campaign: state => state.campaign.current,
      paymentId: state => state.paymentType.paymentId,
    }),

    ...mapGetters({
      paymentTypeData: 'paymentType/getGuaranteePaymentMethods',
    }),

    depositList() {
      return (
        this.paymentTypeData?.filter(i => i?.type === 'deposit') ?? []
      )
    },

    isSelectedDepositList() {
      return this.depositList.some(item => item.id === this.paymentId)
    },

    fullPaymentList() {
      return (
        this.paymentTypeData?.filter(
          i => i?.type === 'full-payment',
        ) ?? []
      )
    },

    isShowFullPaymentMethod() {
      return this.fullPaymentList.length > 0
    },

    isSelectedFullPaymentList() {
      return this.fullPaymentList.some(
        item => item.id === this.paymentId,
      )
    },

    payAtStoreList() {
      return (
        this.paymentTypeData?.filter(
          i => i?.type === 'pay-at-store',
        ) ?? []
      )
    },

    isSelectedPayAtStoreList() {
      return this.payAtStoreList.some(
        item => item.id === this.paymentId,
      )
    },

    installmentList() {
      return (
        this.paymentTypeData?.filter(
          i => i?.type === 'installment',
        ) ?? []
      )
    },

    isShowInstallmentMethod() {
      return this.installmentList.length > 0
    },

    isSelectedInstallmentList() {
      return this.installmentList.some(
        item => item.id === this.paymentId,
      )
    },

    appList() {
      return []
    },

    isShowAppMethod() {
      return this.appList.length > 0
    },

    isSelectedAppList() {
      return this.appList.some(item => item.id === this.paymentId)
    },

    appListDeposit() {
      return []
    },

    isSelectedAppListDeposit() {
      return this.appListDeposit.some(
        item => item.id === this.paymentId,
      )
    },

    disabledButton() {
      if (this.isVerifyRecaptcha) {
        return !this.checkAgree || !this.validateRecaptcha
      }
      return !this.checkAgree
    },

    checkValid() {
      if (this.isVerifyRecaptcha) {
        return this.checkAgree && this.validateRecaptcha
      }
      return this.checkAgree
    },

    isVerifyRecaptcha() {
      return this.campaign?.data?.is_verify_recaptcha === 1
    },

    isShowPayAtStoreMethod() {
      const { t } = this.$route.query

      return (
        this.payAtStoreList.length > 0 &&
        (t === STOCK_CARD_TYPE.STORE || t === STOCK_CARD_TYPE.QR)
      )
    },

    form() {
      return {
        order_id:
          this.$route.params?.uid ||
          this.$route.params?.orderId ||
          null,
        payment_gw: this.paymentId == 4 ? 'kbank' : null,
      }
    },
  },

  async mounted() {
    this.autoSelectPayment()
  },

  data() {
    return {
      colorBnn,
      iconBank,
      scrollY,
      validateRecaptcha: false,
      checkAgree: true,
      isShowTerm: false,
      positionCheckoutAction: 0,
      installmentPlan: null,
    }
  },

  methods: {
    validate(success) {
      this.validateRecaptcha = success
    },

    onSelectPaymentMethod(event) {
      this.$store.commit('paymentType/setPaymentId', event.id)
      this.$emit('onSelectPaymentMethod', event.id)

      let plan = event.dropdown ? JSON.parse(event.dropdown) : null
      if (plan) {
        this.$store.commit(
          'paymentType/setPaymentInstallmentPlan',
          plan?.[0],
        )
        this.installmentPlan = plan?.[0]
      } else {
        this.$store.commit(
          'paymentType/setPaymentInstallmentPlan',
          null,
        )
        this.installmentPlan = null
      }

      this.$forceUpdate()
    },

    autoSelectPayment() {
      this.onSelectPaymentMethod(this.fullPaymentList[0])
    },

    handleUpdateInstallmentPlan(value) {
      this.$store.commit(
        'paymentType/setPaymentInstallmentPlan',
        value,
      )
    },

    async onSubmit() {
      switch (this.paymentId) {
        case 4:
          await this.handlePayWithKBank()
          break
        default:
          await this.handlePayWithKBank()
      }
    },

    async handlePayWithKBank() {
      try {
        const response = await axios
          .post('/payment/guarantee/pay', this.form)
          .then(res => res.data.data)

        if (Object.keys(response).length === 0) {
          this.$toast.error(
            'เกิดข้อผิดพลาดในการชำระเงิน กรุณาลองใหม่อีกครั้ง',
            {
              duration: 5000,
              position: 'top',
            },
          )
          return
        }

        this.handlePayWithKBankEmbedUI(response)
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          'เกิดข้อผิดพลาดในการชำระเงิน กรุณาลองใหม่อีกครั้ง'

        this.$toast.error(errorMessage, {
          duration: 5000,
          position: 'top',
        })
      }
    },

    handlePayWithKBankEmbedUI(event) {
      try {
        const embeds = {
          ref_id: event?.ref_id,
          merchant_id: event?.merchant_id,
          apiKey: event?.public_apikey,
          amount: event?.amount,
          currency: event?.currency,
          smartpayId: event?.smartpay_id,
          smartpayTerm: event?.smartpay_term,
          scriptUrl: event?.script_url,
          endpoint: event?.action_url,
        }

        showKBankEmbedUI(embeds)
      } catch {
        this.$toast.error(
          'เกิดข้อผิดพลาดในการชำระเงิน กรุณาลองใหม่อีกครั้ง',
          {
            duration: 5000,
            position: 'top',
          },
        )
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.isLoading
  cursor not-allowed !important
  opacity 0.6

.chanel-payment-grid
  display: grid
  gap: 24px
  margin-bottom 32px
  grid-template-columns: repeat(2, 1fr)
  @media medium
     grid-template-columns: repeat(1, 1fr)
     gap: 24px 0
  @media small
     grid-template-columns: repeat(1, 1fr)
     gap: 16px 0

.payment-label
  margin: 1rem 0

.payment-methods-container
  background-color: #f5f5f7
  padding: 32px 0

.payment-methods-actions-container
  display: flex
  flex-direction: column
  align-items: center
  gap: 24px
  margin-top: 16px
</style>
